/**
 * env.pre.js 为pre环境配置，会对env.js进行扩展。
 * */
export default {
  env: 'pre', // pre环境变量
  FLEET_API_URL: 'https://pre-gasweb-us.99app.com',
  PUBLIC_URL:
    'https://s3-us01.didiglobal.com/ibt-mobility-fe-static/driver-lab/driver-service-backend-pre'
};
